import type { FocusEventHandler } from 'react'

import NextLink from 'next/link'

export interface LinkProps {
  ref?: React.Ref<HTMLAnchorElement>
  route: string
  children?: React.ReactNode
  openInNewTab?: boolean
  className?: string
  prefetch?: boolean
  onFocus?: FocusEventHandler<HTMLAnchorElement>
  tabIndex?: number
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function Link({
  ref,
  children,
  openInNewTab = true,
  route,
  className,
  prefetch = true,
  onFocus,
  tabIndex = 0,
  ...props
}: LinkProps) {
  return (
    <NextLink
      ref={ref}
      href={route}
      target={openInNewTab ? '_blank' : undefined}
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
      className={className}
      prefetch={prefetch}
      onFocus={onFocus}
      tabIndex={tabIndex}
      {...props}
    >
      {children}
    </NextLink>
  )
}
